import { Link } from "react-router-dom";
import { SiteNav, SiteFooter } from "./SiteChrome";
import { useSeo } from "../lib/seo";
import "../styles/site.css";

export default function MarketingPage({ seo, crumb, eyebrow, h1, lead, sections, cta }) {
  useSeo(seo);
  return (
    <div className="site" data-testid={seo.testid || "marketing-page"}>
      <SiteNav />
      <section>
        <div className="wrap narrow">
          <nav className="crumb" aria-label="Breadcrumb">
            <Link to="/">Home</Link><i>/</i><span>{crumb}</span>
          </nav>
          {eyebrow && <span className="kicker">{eyebrow}</span>}
          <h1 className="serif" style={{ fontSize: "clamp(2.2rem,5vw,3.4rem)", letterSpacing: "-.03em", lineHeight: 1.02, marginTop: 14 }}>{h1}</h1>
          {lead && <p className="lead">{lead}</p>}
          <div className="prose" style={{ marginTop: 34 }}>
            {sections.map((s, i) => (
              <div key={i}>
                <h2>{s.h2}</h2>
                {s.p && s.p.map((para, j) => <p key={j}>{para}</p>)}
                {s.bullets && <ul>{s.bullets.map((b, j) => <li key={j}>{b}</li>)}</ul>}
              </div>
            ))}
          </div>
          {cta && (
            <a className="btn" href={cta.href} target={cta.external ? "_blank" : undefined} rel={cta.external ? "noopener noreferrer" : undefined} style={{ marginTop: 38 }} data-testid="page-cta">{cta.label}</a>
          )}
        </div>
      </section>
      <SiteFooter />
    </div>
  );
}
